import type { LucideIcon } from 'lucide-react';
import {
    Receipt,
    Store,
    Package,
    CreditCard,
    Landmark,
    HandCoins,
    Users,
    SlidersHorizontal,
} from 'lucide-react';

/**
 * Secciones del backoffice SureKeep (Fase 1). Menú básico placeholder para compartir:
 * cada una lleva a una pantalla "próximamente" hasta que se construyan de verdad.
 * Fuente: componente 10 (loan-backoffice-webapp) — las 7 secciones de la F1.
 */
export interface BackofficeSection {
    key: string;
    label: string;
    icon: LucideIcon;
}

export const BACKOFFICE_SECTIONS: BackofficeSection[] = [
    // Ventas va primero: es la operación diaria del admin de la cadena, no una sección de consulta.
    { key: 'ventas', label: 'Ventas', icon: Receipt },
    { key: 'operacion-retail', label: 'Operación retail', icon: Store },
    { key: 'catalogo', label: 'Catálogo de productos', icon: Package },
    { key: 'tarjetas-pcf', label: 'Tarjetas PCF', icon: CreditCard },
    { key: 'planes-credito', label: 'Planes de crédito', icon: HandCoins },
    { key: 'financieras', label: 'Financieras', icon: Landmark },
    { key: 'asignacion-cartera', label: 'Asignación de cartera', icon: Users },
    { key: 'parametros', label: 'Parámetros', icon: SlidersHorizontal },
];

export function sectionByKey(key: string): BackofficeSection | undefined {
    return BACKOFFICE_SECTIONS.find((s) => s.key === key);
}
